import React, { useEffect } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { Table, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { adminListUsers, adminDeleteUser } from "../actions/userActions";
import Message from "../components/Message";
import Loader from "../components/Loader";
import ShowOffers from "../components/ShowOffers";

const UserListScreen = ({ history }) => {
  const dispatch = useDispatch();

  const userListAdmin = useSelector((state) => state.userListAdmin);
  const { loading, error, users } = userListAdmin;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const userDeleteAdmin = useSelector((state) => state.userDeleteAdmin);
  const { success: successDelete } = userDeleteAdmin;

  console.log(users);

  useEffect(() => {
    if (userInfo && userInfo.isAdmin) {
      dispatch(adminListUsers());
    } else {
      history.push("/login");
    }
  }, [dispatch, history, userInfo, successDelete]);

  const deleteHandler = (id) => {
    if (window.confirm("Are you sure?")) {
      dispatch(adminDeleteUser(id));
    }
  };

  return (
    <>
      <h1 style={{ marginTop: "5rem" }}>Users</h1>
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <Table striped bordered hover responsive className='table-sm'>
          <thead>
            <tr>
              <th>ID</th>
              <th>NAME</th>
              <th>EMAIL</th>
              <th>OFFER USED</th>
              <th>ADMIN</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td>{user._id}</td>
                <td>{user.name}</td>

                <td>
                  <a href={`mailto:${user.email}`}>{user.email}</a>
                </td>
                {user.appliedOffers.length === 0 ? (
                  <td>"No Offers Yet" </td>
                ) : (
                  <td>
                    <ShowOffers offers={user.appliedOffers} />
                  </td>
                )}

                <td>
                  {user.isAdmin ? (
                    <i className='fas fa-check' style={{ color: "green" }}></i>
                  ) : (
                    <i className='fas fa-times' style={{ color: "red" }}></i>
                  )}
                </td>
                <td>
                  <LinkContainer to={`/admin/user/${user._id}/edit`}>
                    <Button variant='light' className='btn-sm'>
                      <i className='fas fa-edit'></i>
                    </Button>
                  </LinkContainer>

                  <Button
                    variant='danger'
                    className='btn-sm'
                    onClick={() => deleteHandler(user._id)}
                  >
                    <i className='fas fa-trash'></i>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default UserListScreen;
